import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Is this free?',
      answer: 'Yes. The False Self Assessment is completely free. No credit card. No hidden fees. Just your results.'
    },
    {
      question: 'How long does this take?',
      answer: '2 minutes. 25 questions. No fluff.'
    },
    {
      question: 'Is this another personality test?',
      answer: 'No. This identifies the survival identity installed in childhood that\'s sabotaging your growth. It\'s not about preferences. It\'s about patterns.'
    },
    {
      question: 'What are the five False Self archetypes?',
      answer: 'Performer (validation-seeking), Ghost (emotionally withdrawn), Controller (authority-seeking), Pleaser (approval-seeking), Destroyer (self-sabotaging). Most men have a dominant pattern with secondary traits.'
    },
    {
      question: 'How accurate is this?',
      answer: 'Based on validated psychological principles. Accuracy depends on honest answers. Most men report the results are uncomfortably accurate.'
    },
    {
      question: 'What happens after I complete it?',
      answer: 'You\'ll get a personalized report identifying your dominant pattern, the internal conflict driving your behavior, and specific strategies to install new patterns.'
    },
    {
      question: 'Why do I need to provide my email?',
      answer: 'We send your results via email. You can access them anytime. We don\'t spam. We don\'t sell your data. Period.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full bg-brand-black py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-white mb-4 uppercase tracking-tight">
            Questions
          </h2>
          <p className="text-lg md:text-xl text-brand-steel">
            Direct answers. No marketing speak.
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq, index) => (
            <div 
              key={index}
              className="bg-brand-charcoal rounded-lg border border-brand-slate overflow-hidden transition-all duration-250"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 p-6 text-left hover:bg-brand-slate/50 transition-colors duration-250"
              >
                <span className="font-bold text-brand-white text-base flex-1 uppercase tracking-wide">
                  {faq?.question}
                </span>
                <Icon 
                  name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  color="#C9A227"
                  className="flex-shrink-0"
                />
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6 pt-0">
                  <p className="text-base text-brand-steel leading-relaxed">
                    {faq?.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Support */}
        <div className="mt-12 text-center">
          <p className="text-base text-brand-steel mb-4">
            Still have questions?
          </p>
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-brand-charcoal rounded-lg border border-brand-slate">
            <Icon name="Mail" size={18} color="#C9A227" />
            <span className="text-base font-semibold text-brand-white">
              support@limitlessmen.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;